// generated by bun run generate from the SwiftUI SDK and codegen/catalog.ts.
// edit the generator or catalog, then regenerate.
import type { ViewProps } from 'react-native';
import type { DirectEventHandler, Int32 } from 'react-native/Libraries/Types/CodegenTypes';
import codegenNativeComponent from 'react-native/Libraries/Utilities/codegenNativeComponent';
interface NativeProps extends ViewProps {
  active: boolean;
  autoEnter: boolean;
  onNativePictureInPictureChange?: DirectEventHandler<Readonly<{
    active: boolean;
  }>>;
}
const NativeComponentRegistry = require('react-native/Libraries/NativeComponent/NativeComponentRegistry');
const {
  ConditionallyIgnoredEventHandlers
} = require('react-native/Libraries/NativeComponent/ViewConfigIgnore');
let nativeComponentName = 'OneNativePictureInPicture';
export const __INTERNAL_VIEW_CONFIG = {
  uiViewClassName: "OneNativePictureInPicture",
  directEventTypes: {
    topNativePictureInPictureChange: {
      registrationName: "onNativePictureInPictureChange"
    }
  },
  validAttributes: {
    active: true,
    autoEnter: true,
    ...ConditionallyIgnoredEventHandlers({
      onNativePictureInPictureChange: true
    })
  }
};
export default NativeComponentRegistry.get(nativeComponentName, () => __INTERNAL_VIEW_CONFIG);